import { initializeMultiregionForm } from '../../profileConfiguration/actions';

export default (data) =>
    initializeMultiregionForm({
        ...data,
        language: data.settings ? data.settings.language.key : null,
        timezone: data.settings ? data.settings.timezone.key : null,
        auto_timezone: data.settings ? data.settings.auto_timezone : false,
    });
